import {
    Button,
    Pagination,
    Popconfirm,
    Spin,
    Table,
    Tag,
    Input,
    message,
    Switch,
    Select,
    Flex,
    Popover,
    Form,
    Drawer,
    List,
} from "antd";
import React, { useEffect, useState } from "react";
import { ExtractDate, ExtractTime, messageConfiguration } from "../../../utils";
//   import {
//     updateActivationStatus,
//   } from "./orderapiFunctions";
import { addRestro, getordersDetails, getrestroPermissionsList, updateRole, userRegister } from "../../../ApiServices/Apifun";
import {
    DeleteOutlined,
    LoadingOutlined,
    PlusCircleOutlined,
    PlusOutlined,
} from "@ant-design/icons";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ComponentTitle from "../../../Common/ComponentTitle";
import { render } from "@testing-library/react";
import errorImage from "../../../assets/images/food.png"


const Permissions = () => {
    const [orderData, setorderData] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [currentStatus, setCurrentStatus] = useState();
    const [loader, setloader] = useState(false);
    const [form] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [addloader, setaddloader] = useState(false);
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [action, setAction] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const { Search } = Input;
    const navigate = useNavigate();
    const location = useLocation();
    const { id } = useParams();
    const from = location.state?.from;
    console.log(from);

    const [isDrawerVisible, setIsDrawerVisible] = useState(false);
    const [selectedPermissions, setSelectedPermissions] = useState([]);

    const handleFormSubmit = (id) => {
        updateRole(`?permissionId=${id}`)
            .then((response) => {
                if (response.status) {
                    message.success("Status updated successfully");
                    setIsDrawerVisible(false);
                    FetchordersDetails(currentPage); // Refresh the list to show the updated status
                } else {
                    message.error("Failed to update status");
                }
            })
            .catch((err) => {
                console.error("Error updating status:", err);
                message.error("An error occurred while updating the status");
            });
    };

    const showDrawer = (restaurantss) => {
        // Map through restaurantss to extract roleName, permissionName, and status
        const permissions = restaurantss.map((item) => ({
            roleName: item.roles?.roleName, // Role name
            permissionName: item.permissions?.permissionName, // Permission name
            isActive: item.permissions?.isActive, // Status
            permissionId: item.permissions?.id, // permissionId
        }));

        setSelectedPermissions(permissions); // Set permissions data
        setIsDrawerVisible(true);            // Show the drawer
    };


    const closeDrawer = () => {
        setIsDrawerVisible(false);
    };
    const FetchordersDetails = (page) => {
        setIsLoading(true);
        getrestroPermissionsList(`?page=${page}&limit=5`)
            .then((response) => {
                if (response.status) {
                    setorderData(response.data || []);
                    setCurrentPage(response.pagination.page || 1);
                    setTotalPages(response.pagination.totalPages || 0);
                }
                setIsLoading(false);
            })
            .catch((err) => {
                console.error("Error fetching order details:", err);
                setIsLoading(false);
            });
    };
    const handlePageChange = (page) => {
        setCurrentPage(page); // Update state to trigger useEffect
    };

    // function changeActiveStatus(checked, record) {
    //   console.log(checked, record);
    //   const isDeleteAction = checked === undefined;

    //   let payload = {
    //     name: record.name,
    //     is_active: isDeleteAction ? (checked ? "1" : "0") : record.is_active,
    //     is_deleted: isDeleteAction ? "0" : "1",
    //   };

    //   updateActivationStatus(payload, record.id)
    //     .then((response) => {
    //       if (response.data.status === "success") {
    //         const updatedorderTable = orderData.map((item) =>
    //           item.id === record.id
    //             ? {
    //               ...item,
    //               is_active: isDeleteAction
    //                 ? item.is_active
    //                 : payload.is_active,
    //             }
    //             : item
    //         );
    //         setorderData(updatedorderTable);
    //         FetchordersDetails(currentPage);
    //         message.open(
    //           messageConfiguration(
    //             "success",
    //             isDeleteAction
    //               ? "Category deleted successfully."
    //               : response.message,
    //             3
    //           )
    //         );
    //         if (!isDeleteAction) {
    //           FetchordersDetails(currentPage);
    //         }
    //       }
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       message.open(
    //         messageConfiguration(
    //           "error",
    //           isDeleteAction
    //             ? "Failed to delete category."
    //             : "Failed to update status.",
    //           3
    //         )
    //       );
    //     });

    // }

    const handleErrorImage = (e) => {

        e.target.src = errorImage

    }
    // console.log("tottaaaaaaaaaaal", totalPage);
    const setwithdrawAction = (id, value) => {
        setAction((prevAction) => ({
            ...prevAction,
            [id]: value,
        }));
    };

    useEffect(() => {
        FetchordersDetails(currentPage);
    }, [currentPage]);

    const handleDrawerClose = () => {
        setOpenModal(false);
    };



    const columns = [
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
            className: "custom-header",
        },
        // {
        //     title: "Email",
        //     dataIndex: "email",
        //     key: "email",
        //     className: "custom-header",
        // },
        {
            title: "Phone no.",
            dataIndex: "mobile_number",
            key: "mobile_number",
            className: "custom-header",
        },
        // {
        //     title: "Created Time",
        //     dataIndex: "createdAt",
        //     key: "createdAt",
        //     className: "custom-header",
        //     render: (data) => (
        //         <p className="text-xs">
        //             {ExtractDate(data)} {ExtractTime(data)}
        //         </p>
        //     ),
        // },
        {
            title: "View Role",
            dataIndex: "restaurantss",
            key: "restaurantss",
            className: "custom-header",
            render: (role) => (
                <Button
                    type="link"
                    onClick={() => showDrawer(role || [])}
                >
                    {"View"}
                </Button>
            ),
        },
    ];

    return (
        <div>
            <div className="flex items-end justify-end m-2">
                {/* <Search
                    placeholder="search..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ width: "26%" }}
                /> */}
            </div>
            <div
                //   style={{ maxHeight: "540px", overflow: "auto" }}
                className="shadow-sm shadow-gray-300"
            >
                {" "}
                <Table

                    bordered={true}
                    loading={isLoading}
                    columns={columns}
                    dataSource={orderData}
                    pagination={false}
                    className="w-screen sm:w-screen   custom-table-header"
                    size="small"
                />
            </div>
            <Pagination
                className="mt-2 text-xs w-full flex justify-end"
                total={totalPages * 10} // Assuming 10 items per page
                showTotal={(total, range) =>
                    `${range[0]}-${range[1]} of ${totalPages * 10} items`
                }
                onChange={handlePageChange}
                defaultPageSize={10}
                current={currentPage}
            />
            {/* Drawer to display permissions */}
            <Drawer
                title="Role Permissions"
                placement="right"
                onClose={closeDrawer}
                visible={isDrawerVisible}
                width={400}
            >
                {selectedPermissions.length > 0 ? (
                    <List
                        dataSource={selectedPermissions}
                        renderItem={(item) => (

                            <List.Item>
                                <div style={{ width: "100%" }}>
                                    <p>
                                        <strong>Role: </strong> {item.roleName}
                                    </p>
                                    {console.log(item)}
                                    <p>
                                        <strong>Permission: </strong> {item.permissionName}
                                    </p>
                                    <p>
                                        <strong>Status: </strong>{" "}
                                        {item.isActive === "1" ? "Active" : "Inactive"}
                                    </p>
                                    {/* Add a Button to Update Status */}
                                    <Button
                                        type="primary"
                                        onClick={() => handleFormSubmit(item.permissionId)}
                                    >
                                        {item.isActive === "1" ? "Deactivate" : "Activate"}
                                    </Button>
                                </div>
                            </List.Item>
                        )}
                    />
                ) : (
                    <p>No permissions available</p>
                )}
            </Drawer>
        </div>
    );
};
export default Permissions;
